(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/xperten.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/xperten.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Xperten = Marionette.View.extend({
    className: 'view-xperten xperten padding-1',

    template: function(data) {
      return svs.matchen.templates.xperten(data);
    },

    events: {
      'change .js-xperten': 'onChange'
    },

    changeDoneButtonState: function(disabled) {
      $('.modal-button-right').prop('disabled', disabled);
    },

    onChange: function(event) {
      this.changeDoneButtonState(false);
      this.model.set('trySystemSize', $(event.target).val(), { silent: true });
    },

    onClose: function() {
      if (!this.isDestroyed()) {
        this.destroy();
      }
    }
  });
})(Backbone, _, svs);


 })(window);